/*
 * piner product detail:
 *   galleries (arrows, counter, hover halves), the View switch over the
 *   right-hand image sets, size selection, add to bag, the Fabric / Feature /
 *   Size Guide / Details panels, and the mobile action bar that docks into the
 *   flow once you scroll to it.
 * Self-contained: no imports, load with a plain deferred <script>.
 */
(function pinerProduct() {
  var MOBILE = 768;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE + 'px)').matches;
  }

  /* ---------------- galleries ---------------- */

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-pdp-track]');
    var count = gallery.querySelector('[data-pdp-count]');
    var prev = gallery.querySelector('[data-pdp-prev]');
    var next = gallery.querySelector('[data-pdp-next]');
    if (!track) return;

    var slides = track.children.length;
    if (!slides) return;

    function index() {
      // Slides are exactly one track-width wide, so this rounds to the one in view.
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function sync() {
      // Galleries for the views that aren't showing have no size to measure.
      if (!track.clientWidth) return;
      var i = index();
      if (count) count.textContent = i + 1 + '/' + slides;
      // The board shows only ">" on the first image and only "<" on the last.
      if (prev) prev.hidden = i <= 0;
      if (next) next.hidden = i >= slides - 1;
    }

    function go(delta) {
      track.scrollTo({ left: (index() + delta) * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    track.addEventListener('scroll', function () {
      window.clearTimeout(track._pinerTimer);
      track._pinerTimer = window.setTimeout(sync, 60);
    });
    window.addEventListener('resize', sync);

    sync();
  }

  /* ---------------- buy box ---------------- */

  function initBuyBox(root) {
    var form = root.querySelector('[data-pdp-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-pdp-variant-id]');
    var sizes = form.querySelectorAll('[data-pdp-size]');
    var sizeGroup = form.querySelector('[data-pdp-sizes]');
    var button = form.querySelector('[data-pdp-atb]');

    sizes.forEach(function (size) {
      size.addEventListener('click', function () {
        if (size.disabled) return;
        // Match on the variant so the info column and the mobile sheet both
        // show the same size as chosen.
        sizes.forEach(function (other) {
          other.classList.toggle('is-selected', other.dataset.variantId === size.dataset.variantId);
        });
        if (variantInput) variantInput.value = size.dataset.variantId || '';
        if (sizeGroup) sizeGroup.classList.remove('is-missing');
      });
    });

    var sheet = form.querySelector('[data-pdp-sheet]');

    function sheetOpen() {
      return sheet && !sheet.hidden;
    }

    function openSheet() {
      if (!sheet) return;
      sheet.hidden = false;
      document.body.classList.add('pdp-sheet-open');
    }

    function closeSheet() {
      if (!sheet) return;
      sheet.hidden = true;
      document.body.classList.remove('pdp-sheet-open');
    }

    // Tapping away from the sheet, or Escape, puts it back down.
    document.addEventListener('click', function (event) {
      if (!sheetOpen()) return;
      if (event.target.closest('[data-pdp-sheet]')) return;
      if (event.target.closest('[data-pdp-atb]')) return;
      closeSheet();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSheet();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (variantInput && !variantInput.value) {
        // Nothing picked yet. On mobile the bar floats above the page until it
        // reaches its place: while it is floating the real rows are out of
        // reach, so the boards raise a sheet when a panel is covering them and
        // otherwise carry you down to the rows themselves.
        var floating = button && !button.classList.contains('is-docked');
        if (isMobile() && floating) {
          if (document.body.classList.contains('pdp-panel-open') || sheetOpen()) {
            openSheet();
          } else if (sizeGroup) {
            sizeGroup.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
          return;
        }

        // Otherwise the rows are right there — point at them.
        if (sizeGroup) {
          sizeGroup.classList.remove('is-missing');
          void sizeGroup.offsetWidth; // restart the nudge
          sizeGroup.classList.add('is-missing');
          sizeGroup.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        return;
      }

      closeSheet();

      if (button) button.setAttribute('aria-busy', 'true');

      // Asking for the drawer section in the same call means the freshly
      // rendered cart comes back with the add — no second round-trip, and no
      // second implementation of the totals.
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantInput.value), quantity: 1 }],
          sections: 'piner-cart-drawer',
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function (result) {
          var cart = window.pinerCart;
          if (!cart) return;
          // A section that fails to render comes back as null with a 200, so
          // replace() keeps the old markup and we still open what we have.
          cart.replace(result.sections && result.sections['piner-cart-drawer']);
          cart.open();
        })
        .catch(function () {
          /* the bag simply stays as it was */
        })
        .then(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------------- view switch ---------------- */

  /* The right-hand gallery swaps between the product's image sets. All three
     are already in the DOM, so this only moves an attribute on <html> — the
     header sets it before paint, this keeps it in step afterwards. */
  function initViewSwitch(root) {
    var available = (root.dataset.pdpViews || '').split(',').filter(Boolean);
    if (!available.length) return;

    function current() {
      var value = document.documentElement.getAttribute('data-pdp-view');
      return available.indexOf(value) !== -1 ? value : available[0];
    }

    function mark() {
      var view = current();
      document.querySelectorAll('[data-pdp-view-set]').forEach(function (button) {
        button.classList.toggle('is-current', button.dataset.pdpViewSet === view);
      });
    }

    function set(view) {
      if (available.indexOf(view) === -1) return;
      document.documentElement.setAttribute('data-pdp-view', view);

      try {
        // Remembered so it survives a hop to another colourway.
        localStorage.setItem('piner:pdpview', view);
      } catch (e) {}

      mark();
      // The gallery that just appeared has never been measured.
      window.dispatchEvent(new Event('resize'));
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pdp-view-set]');
      if (!button) return;
      set(button.dataset.pdpViewSet);

      var list = button.closest('.depth-list');
      if (list) {
        list.classList.remove('is-active');
        var trigger = list.parentElement.querySelector('[data-depth-toggle]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // The header may have resolved to a view this product cannot show.
    document.documentElement.setAttribute('data-pdp-view', current());
    mark();
  }

  /* ---------------- panels ---------------- */

  function initPanels() {
    var panel = document.querySelector('[data-pdp-panel-root]');
    if (!panel) return;

    var dim = document.querySelector('[data-pdp-dim]');
    var scroll = panel.querySelector('[data-pdp-scroll]');
    var tabs = panel.querySelectorAll('[data-pdp-tab]');
    var panes = panel.querySelectorAll('[data-pdp-pane]');

    /* The bottom fade only means something while there is more to reach */
    function syncOverflow() {
      if (!scroll) return;
      var more = scroll.scrollTop + scroll.clientHeight < scroll.scrollHeight - 2;
      scroll.classList.toggle('has-more', more);
    }

    function show(name) {
      var found = false;
      panes.forEach(function (pane) {
        var match = pane.dataset.pdpPane === name;
        pane.hidden = !match;
        if (match) found = true;
      });
      if (!found) return false;

      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.dataset.pdpTab === name);
      });

      panel.hidden = false;
      document.body.classList.add('pdp-panel-open');
      if (dim) dim.classList.add('is-open');
      if (scroll) scroll.scrollTop = 0;
      // Measure now, then again after layout — a pane's images can land late
      // and change how much there is to scroll.
      syncOverflow();
      window.requestAnimationFrame(syncOverflow);
      return true;
    }

    function close() {
      panel.hidden = true;
      document.body.classList.remove('pdp-panel-open');
      if (dim) dim.classList.remove('is-open');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pdp-panel]');
      if (trigger) {
        show(trigger.dataset.pdpPanel);
        return;
      }

      var tab = event.target.closest('[data-pdp-tab]');
      if (tab) {
        show(tab.dataset.pdpTab);
        return;
      }

      if (event.target.closest('[data-pdp-close]') || event.target.closest('[data-pdp-dim]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) close();
    });

    if (scroll) {
      scroll.addEventListener('scroll', syncOverflow, { passive: true });
      // Panel imagery is lazy, so re-measure as it arrives.
      scroll.addEventListener('load', syncOverflow, true);
    }
    window.addEventListener('resize', syncOverflow);

    initUnits(panel);
  }

  /* Measurements are entered in cm; inches are derived here so the merchant
     only ever maintains one set of numbers. The boards ask for one decimal in
     half-unit steps. */
  function initUnits(panel) {
    var table = panel.querySelector('[data-pdp-size-table]');
    var buttons = panel.querySelectorAll('[data-pdp-unit-set]');
    if (!table || !buttons.length) return;

    var cells = table.querySelectorAll('td[data-cm]');

    function apply(unit) {
      cells.forEach(function (cell) {
        var cm = parseFloat(cell.dataset.cm);
        if (isNaN(cm)) return;
        if (unit === 'inch') {
          cell.textContent = (Math.round((cm / 2.54) * 2) / 2).toFixed(1);
        } else {
          cell.textContent = cell.dataset.cm;
        }
      });
      buttons.forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.pdpUnitSet === unit);
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        apply(button.dataset.pdpUnitSet);
      });
    });
  }

  /* ---------------- mobile action bar ---------------- */

  /* The bar floats at the bottom of the screen and drops into its own place in
     the flow once that place is on screen — the boards call this "버튼화". */
  function initStickyBar(root) {
    var button = root.querySelector('[data-pdp-atb]');
    if (!button) return;

    // The anchor reserves the bar's place in the flow (see the stylesheet), so
    // the page never reflows when the bar lands — which is what would otherwise
    // make this oscillate.
    var anchor = document.createElement('div');
    anchor.className = 'pdp-atb-anchor';
    button.parentNode.insertBefore(anchor, button);

    function update() {
      if (!isMobile()) {
        button.classList.remove('is-docked');
        return;
      }
      // Land once the reserved slot has fully scrolled into view.
      var slot = anchor.getBoundingClientRect();
      button.classList.toggle('is-docked', slot.bottom <= window.innerHeight);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    root.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
    initViewSwitch(root);
    initBuyBox(root);
    initStickyBar(root);
    initPanels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
